(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.messages');
    module.directive('messageTable', ['$rootScope', '$uibModal', 'ItemTableService', 'Message', 'OnlineBooking', 'MessageType', 'HelperService', MessageTableFn]);

    function MessageTableFn($rootScope, $uibModal, ItemTableService, Message, OnlineBooking, MessageType, HelperService) {
        var directive = {
            link: link,
            restrict: 'EA',
            template: '<div ng-include="getTableTemplate()"></div>',
            scope: {
                messages: '=',
                messageTypes: '=',
                transcriptions: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            // table status -> to proof if table is in edit mode
            scope.status = false;
            // pagination
            scope.currentPage = 1; // default
            scope.itemsPerPage = 15;
            // text message flag (for column visibility)
            scope.isSMSType = false;
            scope.isIncomingCall = false;

            // set property, because directive view doesn't have access to rootscope
            scope.isRingfoonAdmin = $rootScope.isRingfoonAdmin;
            scope.isMainAgendaAdmin = $rootScope.isMainAgendaAdmin;
            scope.AICall = MessageType.AICall.value;

            scope.getTableTemplate = function () {
                if (scope.messageTypes === null || scope.messageTypes.length === 0) //not a message but online booking
                    return '/app/settings/messages/templates/message-table-booking.template.html';

                return '/app/settings/messages/templates/message-table.template.html';
            };
            
            // calculates the total duration of all messages
            scope.calculateDuration = function () {
                var hours = 0;
                var minutes = 0;
                var seconds = 0;
                var floor = 0;

                // total duration is only needed for calls
                if (scope.messageTypes !== null && scope.messageTypes.length > 0 && scope.isSMSType === false && scope.messages.length > 0) {
                    for (var i = 0; i < scope.messages.length; i++) {
                        var duration = getDurationParts(scope.messages[i].duration);
                        hours += duration.hours;
                        minutes += duration.minutes;
                        seconds += duration.seconds;
                    }// for

                    // convert summed-up seconds and minutes in a correct time format (for every full 60 seconds, add a minute etc.)
                    if (seconds >= 60) {
                        floor = Math.floor(seconds / 60);
                        minutes += floor;
                        seconds -= floor * 60;
                    }

                    if (minutes >= 60) {
                        floor = Math.floor(minutes / 60);
                        hours += floor;
                        minutes -= floor * 60;
                    }
                } // if

                scope.durationTotal = padTimePart(hours) + ":" + padTimePart(minutes) + ":" + padTimePart(seconds);
            };

            activate();

            /* do activation work */
            function activate() {
                // is text message flag
                if (scope.messageTypes !== null && scope.messageTypes.length > 0) {
                    for (var i = 0; i < scope.messageTypes.length; i++) {
                        if (scope.messageTypes[i] === MessageType.IncomingSMS || scope.messageTypes[i] === MessageType.OutgoingSMSByUser || scope.messageTypes[i] === MessageType.OutgoingSMSByServer) {
                            scope.isSMSType = true;
                        }
                        else if (scope.messageTypes[i] === MessageType.IncomingCall) {
                            scope.isIncomingCall = true;
                        }
                    }
                }

                // init messages list
                ItemTableService.init(scope.messages, null, scope.messageTypes === null || scope.messageTypes.length === 0 ? OnlineBooking : Message);

                // link to variable for show
                scope.messages = ItemTableService.list();

                // status of table
                scope.status = ItemTableService.data;
                scope.calculateDuration();
            }

            // formats a time part (hour/minute...) as double-digit number with leading zeros (i.e. 11:04:02)
            function padTimePart(timePart) {
                var str = timePart + "";
                if (str.length < 2)
                    str = "0" + str;
                return str;
            }

            // helper method to get the duration parts (hours, minutes ...) of a date
            function getDurationParts(date) {
                var dateObj = new Date(date);
                // create new Date object with same date but time set to 0 to calculate duration
                var baseDate = new Date(dateObj);
                baseDate.setHours(0);
                baseDate.setMinutes(0);
                baseDate.setSeconds(0);

                // get the time difference from the base date to the given date in milliseconds
                var diff = dateObj.getTime() - baseDate.getTime();

                // get the hour/minute/second part
                var hours = Math.floor(diff / (1000 * 60 * 60));
                diff -= hours * (1000 * 60 * 60);

                var minutes = Math.floor(diff / (1000 * 60));
                diff -= minutes * (1000 * 60);

                var seconds = Math.floor(diff / 1000);
                diff -= seconds * 1000;

                return {
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds
                };
            } // getDurationParts
        }
    }

})();